<template>
  <div class="step-wrap" :class="{ iframeFontLarge: isInPassport }">
    <p class="mb-20">
      {{ languages.confirmDeleteTitle }} <em class="required">*</em>
    </p>
    <div>
      <van-radio-group v-model="choose">
        <van-radio :name="1"> {{ languages.confirmDeleteYes }}</van-radio>
        <div class="mt-20">
          <TempSelect
            v-if="!loadingGame"
            :formData="formData"
            id="game"
            :customKey="gameCustomKey"
            :disabled="gameDisabled"
          ></TempSelect>
        </div>
        <van-radio :name="0"> {{ languages.confirmDeleteNo }}</van-radio>
      </van-radio-group>
    </div>
    <div class="btn-wrap mb-60">
      <van-button class="btn" block type="info" @click="handleNextStep">
        {{ languages.delNextStep }}
      </van-button>
    </div>
  </div>
</template>

<script>
import TempSelect from '@components/officialSupport/workTemp/TempSelect.vue';
import { mapActions } from 'vuex';
import { stepKey } from '@configs/officialSupport/accountDelete';
import accountDelete from '@mixins/officialSupport/accountDelete';
export default {
  name: 'ConfirmDeleteType',
  mixins: [accountDelete],
  data() {
    return {
      choose: 0,
      formData: {
        game: null
      },
      gameCustomKey: {
        defaultValue: '',
        options: []
      },
      loadingGame: false,
      gameDisabled: false,
      compKey: stepKey.confirmDeleteType
    };
  },
  created() {
    if (this.gameId) {
      this.loadGameOptions(this.gameId);
    }
  },
  methods: {
    ...mapActions(['getGame']),
    // 获取游戏列表
    async loadGameOptions(gameId) {
      try {
        this.loadingGame = true;
        const data = await this.getGame(gameId);
        if (data?.ID && data?.NAME) {
          this.gameCustomKey.defaultValue = gameId;
          this.gameDisabled = true;
          this.gameCustomKey.options = [
            {
              label: data.NAME,
              value: data.ID
            }
          ];
        } else {
          this.gameCustomKey.options = [];
        }
        this.loadingGame = false;
        return Promise.resolve();
      } catch (error) {
        this.gameCustomKey.options = [];
        this.loadingGame = false;
        return Promise.reject();
      }
    },
    handleNextStep() {
      if (this.choose) {
        if (this.formData.game) {
          this.updateGameId(this.formData.game);
          this.updateSubmitForm({
            gameName: this.gameCustomKey.options.find(
              item => item.value == this.formData.game
            ).label
          });
          this.nextStep();
          return;
        } else {
          this.$toast(this.languages.selectGame);
        }
        return;
      }
      this.contactService();
    }
  },
  components: {
    TempSelect
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialSupport/workTempForm.scss';
@import '@assets/scss/officialSupport/accountDelete.scss';
</style>
